import * as React from "react";
import MyChartDataTile from "../dashboard/MyChartDataTile";
import FeatureDisabled from "../common/FeatureDisabled";
import NotAuthorized from "../common/NotAuthorized";
import { withRouter } from 'react-router';
/* eslint-disable react/prop-types */


const MyChartContainer = React.forwardRef((props,ref) => {
    const state = window.store.getState();
    const epicEHRDown = state.common.epicEHRDown;
    const hasMyChartLogin = state.domain.hm;

    const { id, mode, title, heading, footer,content, topBanner, serverData, byroute, submode,
        iframeResizerOptions, src, style, partialView, ignoreChanges, needSectionError, mychartError, containerClass, myChartNotRequired, showLanguageLink, onIframeLoaded,
        leaveOnWindowChange, confirmationModalMsg, confirmationModalBtnTxt1, confirmationModalBtnTxt2, dontShowModalRoute, form
    } = props;
    const bswQtxID = props.bswQtxID && props.bswQtxID.length > 0 ? props.bswQtxID : "bsw_qtx";
    const enableLanguageLink = showLanguageLink !== undefined ? showLanguageLink : true;
    const mychartContainerClass = "container-fluid body-content" + (containerClass ? " " + containerClass : "");
    const authorized = myChartNotRequired ? true : hasMyChartLogin;
    const showQTXSurvey = props.showQTXSurvey ? props.showQTXSurvey : false;
    const events = props.events?props.events: [];

    return authorized ? !epicEHRDown ?
        <div className={mychartContainerClass}>
            {topBanner &&
                topBanner
            }
            <div className="row">
                <div className="col-12 maxWidth-content">
                    {heading &&
                        heading
                    }
                    <MyChartDataTile
                        id={id}
                        mode={mode}
                        formName={form}
                        title={title}
                        serverData={serverData}
                        byroute={byroute}
                        submode={submode}
                        iframeResizerOptions={iframeResizerOptions}
                        src={src}
                        style={style}
                        partialView={partialView}
                        ignoreChanges={ignoreChanges}
                        confirmationModalMsg={confirmationModalMsg}
                        confirmationModalBtnTxt1={confirmationModalBtnTxt1}
                        confirmationModalBtnTxt2={confirmationModalBtnTxt2}
                        needSectionError={needSectionError}
                        mychartError={mychartError}
                        navigation="hide"
                        showLanguageLink={enableLanguageLink}
                        onIframeLoaded={onIframeLoaded}
                        leaveOnWindowChange={leaveOnWindowChange}
                        dontShowModalRoute={dontShowModalRoute}
                        events={events}
                        observe={props.observe}
                        bswMatch={props.bswMatch}
                        onMessage={props.onMessage}
                        onObserved={props.onObserved}
                        showQTXSurvey={showQTXSurvey}
                        bswQtxID={bswQtxID}
                        containerClass={containerClass?containerClass:"" }
                        
                    />
                </div>
            </div>
            { content}
            {footer}
        </div>
        : <FeatureDisabled />
        : <NotAuthorized />;
});


/*onObserved={(messageEvent) => { if (props.onObserved) props.onObserved(messageEvent); }}*/

/* eslint-enable react/prop-types */
export default withRouter(MyChartContainer);